import { AsyncPipe, CommonModule, NgClass } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { TranslocoDirective } from "@jsverse/transloco";
import { ButtonModule } from "primeng/button";
import { CheckboxModule } from 'primeng/checkbox';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { ImageModule } from "primeng/image";
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { SelectModule } from "primeng/select";
import { ProductSliderWraperComponent } from "../custom/product-slider/product-slider-wraper";
import { WholesaleRequestModalComponent } from "../custom/sale-request/wholesale-request-modal.component";
import { AddressCardComponent } from "../shared/components/address-card/address-card.component";
import { AddressFormComponent } from "../shared/components/address-form/address-form.component";
import { CartContentsComponent } from "../shared/components/cart-contents/cart-contents.component";
import { CartTotalsComponent } from "../shared/components/cart-totals/cart-totals.component";
import { RadioCardFieldsetComponent } from "../shared/components/radio-card/radio-card-fieldset.component";
import { RadioCardComponent } from "../shared/components/radio-card/radio-card.component";
import { SignInComponent } from "../shared/components/sign-in/sign-in.component";
import { FormatPricePipe } from "../shared/pipes/format-price.pipe";
import { StripHtmlPipe } from '../shared/pipes/strip-html.pipe';
import { CheckoutPaymentComponent } from "./components/checkout-payment/checkout-payment.component";
4;

export const CheckoutConfirmationComponentImports = [
    CommonModule,
    ButtonModule,
    ProgressSpinnerModule,
    TranslocoDirective,
    RouterModule,
    //Components
];

export const CheckoutPaymentComponentImports = [
    // AsyncPipe,
    // FormsModule,
    // ReactiveFormsModule,
    // CommonModule,
    //Components
];

export const CheckoutShippingComponentImports = [
    AsyncPipe,
    FormatPricePipe,
    CommonModule,
    TranslocoDirective,
    ReactiveFormsModule,
    ImageModule,
    StripHtmlPipe,
    SelectModule,
    ButtonModule,
    DynamicDialogModule,
    //Components
    RadioCardFieldsetComponent,
    RadioCardComponent,
    SignInComponent,
    AddressFormComponent,
    CheckoutPaymentComponent,
    CartContentsComponent,
];

export const CheckoutSignInComponentImports = [
    RouterModule,
    //Components
    SignInComponent
];

export const CheckoutProcessComponentImports = [
    CommonModule,
    AsyncPipe,
    NgClass,
    RouterModule,
    ButtonModule,
    TranslocoDirective,
    //Components
    CartContentsComponent,
    CartTotalsComponent,
    AddressCardComponent,
    CheckboxModule,
    FormsModule,
    WholesaleRequestModalComponent,
    ProductSliderWraperComponent
];

export const CheckoutStageIndicatorComponentImports = [
    CommonModule
    //Components
];
